// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar-2Twaj","companion":"companion-1wa9r","empty":"empty-3i4Rv","name":"name-YzaIK"};